import React, { useEffect, useState } from "react";
import "./header.css";
import ButtonMode from "../ButtonMode";

export const HeaderPortfolio = () => {
  const [showModal, setshowModal] = useState(false);

  return (
    <header className="flex" itemScope itemType="http://schema.org/WPHeader">
      {/* button show modal */}
      <button
        onClick={() => {
          setshowModal(true);
        }}
        className="menu icon-menu flex"
      >
        {" "}
      </button>
      <div />

      <nav itemScope itemType="http://schema.org/SiteNavigationElement">
        <ul className="flex" itemScope itemType="http://schema.org/SiteNavigationElement">
          <li>
            <a href="#About" itemProp="url">
              <span itemProp="name">About</span>
            </a>
          </li>
          <li>
            <a href="#technologie" itemProp="url">
              <span itemProp="name">Technologie</span>
            </a>
          </li>
          <li>
            <a href="#project" itemProp="url">
              <span itemProp="name">Projects</span>
            </a>
          </li>
          <li>
            <a href="#contact" itemProp="url">
              <span itemProp="name">Contact</span>
            </a>
          </li>
        </ul>
      </nav>

      {/* button dark/light mode */}
      <ButtonMode />

      {/* modal */}
      {showModal && (
        <div className="fixed" itemScope itemType="http://schema.org/WPHeader">
          <ul className="modalL">
            <li>
              <button
                className="icon-close"
                onClick={() => {
                  setshowModal(false);
                }}
              />
            </li>
            <li>
              <a href="#About" itemProp="url">
                <span itemProp="name">About</span>
              </a>
            </li>
            <li>
              <a href="#technologie" itemProp="url">
                <span itemProp="name">Technologie</span>
              </a>
            </li>
            <li>
              <a href="#project" itemProp="url">
                <span itemProp="name">Projects</span>
              </a>
            </li>
            <li>
              <a href="#contact" itemProp="url">
                <span itemProp="name">Contact</span>
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};